
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 9a4 4 0 110-8 4 4 0 010 8z","fill":"#fff","stroke":"#fff","stroke-width":"2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M1 20v-1a6 6 0 016-6h4a6 6 0 016 6v1","fill":"#fff"}}),_c('path',{attrs:{"d":"M1 20v-1a6 6 0 016-6h4a6 6 0 016 6v1H1z","stroke":"#fff","stroke-width":"2","stroke-linecap":"square"}})])
          )
        }
      }
    